import { render, staticRenderFns } from "./AnimateSizeChange.vue?vue&type=template&id=7a4c0b94"
import script from "./AnimateSizeChange.vue?vue&type=script&lang=js"
export * from "./AnimateSizeChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports